<div class="card" *ngIf="isView">
    <div class="p-grid">
        <div class="p-col-2">
            <p><strong>Transaction Date: </strong></p>
        </div>
        <div class="p-col-4">
            <p>{{journalDetails?.transactionDate | localDate:'MM/DD/YYYY'}}</p>
        </div>
        <div class="p-col-2">
            <p><strong>Ref No: </strong></p>
        </div>
        <div class="p-col-4">
            <p>{{journalDetails?.referenceNumber}}</p>
        </div>
    </div>
    <div class="p-grid">
        <div class="p-col-12">
            <p-table [value]="journalDetails?.accountTransactions">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Account</th>
                        <th>Debit</th>
                        <th>Credit</th>
                        <th>Memo</th>
                        <th>Created By</th>
                        <th>User</th>
                        <th>Class</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-detail>
                    <tr>
                        <td>{{detail?.financialAccountName}}</td>
                        <td>{{detail?.amount >= 0 ? (detail.amount | customNumberFormat: fractionDigits  | currencySymbol) : ""}}</td>
                        <td>{{detail?.amount
                            < 0 ? ((detail.amount * -1) | customNumberFormat: fractionDigits  | currencySymbol): ""}}</td>
                                <td>{{detail?.lineMemo}}</td>
                                <td>{{detail?.userName}}</td>
                                <td>{{detail?.businessName}}</td>
                                <td>{{detail?.className}}</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
    <div class="p-col-12">
        <p>Memo : {{journalDetails?.memo}}</p>
    </div>
    <p-footer style="float: right;margin-top: 20px;" *ngIf="!fromBill">
        <button type="button" pButton label="Void" [disabled]="isVoided" (click)="voidOrDelete(true)" class="p-mr-2"></button>
        <p-button  [label]="'Delete'" (click)="voidOrDelete(false)" styleClass="p-button-danger" class="p-mr-2"></p-button> 
        <p-button (click)="onDialogClose()" label="Cancel" styleClass="p-button-secondary"></p-button>
    </p-footer>
    </div>

<div class="card" *ngIf="!isView">
    <div class="p-field p-grid" *ngIf="statementMessage">
        <strong [ngClass]="'status-open'">{{statementMessage}}</strong>
    </div>
    <div class="p-field p-grid">
        <div class="p-col-7 p-d-flex">
            <div class="p-mt-2 p-mr-2"><strong>TRANSACTION DATE:</strong></div>
            <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="mm/dd/yyyy" dateFormat="mm/dd/yy" yearRange="1900:2100" 
            [(ngModel)]="transactionDate"></p-calendar>
            <div class="p-field-checkbox p-mb-0" style="margin-right: 6rem">
                <label for="binary" class="p-mr-3">Adjusting Entry</label>
                <p-checkbox [(ngModel)]="isAdjustedEntry" [binary]="true" inputId="binary"></p-checkbox>
            </div>
        </div>
        <div class="p-col-3 p-d-flex" *ngIf="isAllowPostingPeriod">
            <div class="p-mt-2 p-mr-2">
                <label>Posting Period:<span style="color: red">*</span></label>
            </div>
            <!-- journalForm?.get('transactionDate')?.value -->
            <app-posting-period-selector 
                [transactionDate]="isView  ? journalDetails?.transactionDate: transactionDate" 
                [selectedPostingPeriod]="currentPostingPeriodInfo"  [moduleName]="'Journal Entry'"
                (postingInfoChange)="onPostingInfoChange($event)">
            </app-posting-period-selector>
        </div>
        <!-- <div class="p-col-3 p-d-flex">
            <div class="p-mt-2 p-mr-2"><strong>Ref. No:</strong></div>
            <input style="width: auto;" type="text" pInputText  [(ngModel)]="referenceNumber"> 
        </div> -->
        <div class="p-col-2 p-text-right">
            <p-button (click)="addQuantity()" icon="pi pi-plus" label="Add"></p-button>
        </div>
    </div>
    <div class="p-grid">
        <div class="p-col-3">
            <label>Account</label>
        </div>
        <div class="p-col-1">
            <label>Debit</label>
        </div>
        <div class="p-col-1">
            <label>Credit</label>
        </div>
        <div class="p-col-2">
            <label>User</label>
        </div>
        <div class="p-col-3">
            <label>Memo</label>
        </div>
        <div class="p-col-1">
            <label>Class</label>
        </div>
        <div class="p-col-1 p-text-center">
            <label>Delete</label>
        </div>
    </div>
    <!-- <form [formGroup]="journalForm">
        <ng-container formArrayName="quantities">
            <div class="p-field p-grid" *ngFor="let s of quantities().controls; let i = index">
                <ng-container [formGroupName]="i">
                    <div class="p-col-3">
                        <liono-treeSelect class="border-bottom-input" [options]="accountTypes" appendTo="body" display="comma" [metaKeySelection]="false" selectionMode="single" placeholder="Select Account" formControlName="selectedAccountTypes" (onNodeSelect)="onSelectAccountType($event, i)"> </liono-treeSelect>
                    </div>
                    <div class="p-col-1">
                        <p-inputNumber inputId="integeronly" mode="decimal" [min]="0" [minFractionDigits]="fractionDigits" [maxFractionDigits]="fractionDigits" formControlName="debit" (onInput)="onchangeDebit($event, i)" (onBlur)="calTotalDebit(null, i)"></p-inputNumber>
                    </div>
                    <div class="p-col-1">
                        <p-inputNumber inputId="integeronly" mode="decimal" [min]="0" [minFractionDigits]="fractionDigits" [maxFractionDigits]="fractionDigits" formControlName="credit" (onInput)="onchangeCredit($event, i)" (onBlur)="calTotalCredit(null, i)"></p-inputNumber>
                    </div>
                    <div class="p-col-2">
                        <p-dropdown [options]="journalUserType" appendTo="body" optionLabel="name" placeholder="Selected User" formControlName="userType" (onChange)="onSelectUserTyeps($event, i)"> </p-dropdown>
                    </div>
                    <div class="p-col-3 p-d-flex" *ngIf="accountChannelFor.includes(journalForm.get('quantities')['controls'].at(i).get('userType')?.value?.name)">
                        <div class="p-col-6">
                            <p-dropdown [options]="accountChannels" optionLabel="name" appendTo="body" placeholder="Select Account Channel" [filter]="true" formControlName="channel" (onChange)="onChangeAccountChannel(i)" [disabled]="accountChannelDisabledFor.includes(journalForm.get('quantities')['controls'].at(i).get('userType')?.value?.name)"></p-dropdown>
                        </div>
                        <div class="p-col-6">
                            <p-autoComplete 
                                formControlName="selectedAccountDD" 
                                [suggestions]="s?.get('selectedAccountDD')?.customerAccOptions" 
                                (completeMethod)="filterAccount($event, i)" 
                                field="nameWithSequenceNumber" 
                                [minLength]="1" 
                                placeholder="Search Account..." 
                                [disabled]="accountChannelDisabledFor.includes(journalForm.get('quantities')['controls'].at(i).get('userType')?.value?.name)"> 
                                <ng-template let-account pTemplate="account">
                                    <div [ngStyle]="{'padding-left.px': account.level * 10}"> 
                                       {{account?.level > 0 ? '-': ''}} {{ account.nameWithSequenceNumber }}           
                                    </div>
                                </ng-template>
                            </p-autoComplete>
                        </div>
                    </div>
                    <div class="p-col-3" *ngIf="vendorChannelFor.includes(journalForm.get('quantities')['controls'].at(i).get('userType')?.value?.name)">
                        <p-dropdown [options]="vendorAccounts" appendTo="body" optionLabel="name" placeholder="select Account" formControlName="selectedAccountDD" [filter]="true" filterBy="name" [resetFilterOnHide]="true"> </p-dropdown>
                    </div>
                    <div class="p-col-3" *ngIf="employeeChannelFor.includes(journalForm.get('quantities')['controls'].at(i).get('userType')?.value?.name)">
                        <p-dropdown [options]="allUser" appendTo="body" optionLabel="name" placeholder="select Employee" formControlName="selectedAccountDD" [filter]="true" filterBy="name" [resetFilterOnHide]="true"> </p-dropdown>
                    </div>
                    <div class="p-col-1">
                        <liono-treeSelect 
                            class="border-bottom-input full-width" 
                            [options]="classes" 
                            appendTo="body"
                            placeholder="Select Class" 
                            formControlName="class" 
                            display="comma"
                            [metaKeySelection]="false" 
                            selectionMode="single">
                        </liono-treeSelect>
                    </div>
                    <div class="p-col-1 p-text-center">
                        <span class="btnBars p-mr-0" (click)="removeQuantity(i)">
                            <i class="pi pi-minus"></i>
                        </span>
                    </div>
                </ng-container>
            </div>
        </ng-container>
    </form> -->

    <form [formGroup]="journalForm">
        <ng-container formArrayName="quantities">
            <div class="p-field p-grid" *ngFor="let s of quantities().controls; let i = index">
                <ng-container [formGroupName]="i">
                    <div class="p-col-3">
                        <liono-treeSelect class="border-bottom-input" [options]="accountTypes" appendTo="body" display="comma" [metaKeySelection]="false" selectionMode="single" placeholder="Select Account" formControlName="selectedAccountTypes" (onNodeSelect)="onSelectAccountType($event, i)"> </liono-treeSelect>
                    </div>
                    <div class="p-col-1">
                        <p-inputNumber inputId="integeronly" mode="decimal" [min]="0" [minFractionDigits]="fractionDigits" [maxFractionDigits]="fractionDigits" formControlName="debit" (onInput)="onchangeDebit($event, i)" (onBlur)="calTotalDebit(null, i)"></p-inputNumber>
                    </div>
                    <div class="p-col-1">
                        <p-inputNumber inputId="integeronly" mode="decimal" [min]="0" [minFractionDigits]="fractionDigits" [maxFractionDigits]="fractionDigits" formControlName="credit" (onInput)="onchangeCredit($event, i)" (onBlur)="calTotalCredit(null, i)"></p-inputNumber>
                    </div>
                    <div class="p-col-2">
                        <label for="assigned" *ngIf="!journalForm.get('quantities')['controls'].at(i).get('selectedAccountDD')?.value">
                            <div class="p-d-flex p-jc-between">
                                Assign 
                                <span (click)="assignUser(i)" class="hyper-link">
                                    <i class="pi pi-user-edit p-ml-1"></i>
                                </span>
                            </div>
                        </label>
                        <span *ngIf="journalForm.get('quantities')['controls'].at(i).get('selectedAccountDD')?.value">
                            <p-chip styleClass="p-mr-2 custom-chip" label="{{ journalForm.get('quantities')['controls'].at(i).get('selectedAccountDD')?.value?.name }}" [removable]="true"
                                (onRemove)="removeAssignTo(i)">
                            </p-chip>
                        </span>
                    </div>
                    <div class="p-col-3">
                        <input type="text" pInputText placeholder="Memo" formControlName="memo"/>
                    </div>  
                    <div class="p-col-1">
                        <liono-treeSelect 
                            class="border-bottom-input full-width" 
                            [options]="classes" 
                            appendTo="body"
                            placeholder="Select Class" 
                            formControlName="class" 
                            display="comma"
                            [metaKeySelection]="false" 
                            selectionMode="single">
                        </liono-treeSelect>
                    </div>
                    <div class="p-col-1 p-text-center">
                        <span class="btnBars p-mr-0" (click)="removeQuantity(i)">
                            <i class="pi pi-minus"></i>
                        </span>
                    </div>
                </ng-container>
            </div>
        </ng-container>
    </form>
    <div class="p-grid">
        <div class="p-col-3 p-text-right">
            <label>Total:</label>
        </div>
        <div class="p-col-1">
            <label class="p-ml-2" [ngStyle]="debitCreditMismatchHighlighter">{{totalDebit | customNumberFormat: fractionDigits }}</label>
        </div>
        <div class="p-col-1">
            <label class="p-ml-2" [ngStyle]="debitCreditMismatchHighlighter">{{totalCredit | customNumberFormat: fractionDigits }}</label>
        </div>
        <div class="p-col-7"></div>
    </div>
    <div class="p-col-12">
        <textarea pInputTextarea [rows]="2" pInputTextarea placeholder="Memo" [autoResize]="true" [(ngModel)]="memo"></textarea>
    </div>

    <p-footer style="float: right;margin-top: 20px;">
        <button type="button" pButton (click)="onDialogClose()" label="Cancel" class="p-button-secondary p-m-1"></button> 
        <button type="button" pButton label="Save" class="p-m-1" [disabled]="!journalForm?.valid || (isAllowPostingPeriod && !updatedPostingPeriodInfo?.postingDate) || !!statementMessage" (click)="onEditManualJournalEntry('Edit')"></button>
    </p-footer>
</div>
<p-confirmDialog *ngIf="confirmVoid"></p-confirmDialog>
<!-- <p-toast position="top-right" [baseZIndex]="10000"></p-toast> -->
<p-confirmDialog key="account-recivable-payable-dialog" [style]="{width: '20vw'}" [baseZIndex]="1000000"></p-confirmDialog>

<ng-container>
    <app-closing-statement-validation [isClosingDate]="isView == true ? journalDetails?.transactionDate: transactionDate" 
        [moduleName]="'Journal Entry'" (isClosingStatementDate)="isClosingStatementDate($event)">
    </app-closing-statement-validation>
 </ng-container>


 <!-- assign user -->
<p-dialog header="Assign Users" [modal]="true" [responsive]="true" [(visible)]="displayUserList" 
[style]="{ width: '50rem' }" [closable]="false" appendTo="body">
    <div class="header">
        <div class="p-grid">
            <div class="p-col-4">
                <p-dropdown [options]="journalUserType" appendTo="body" optionLabel="name" placeholder="Select User" 
                (onChange)="onSelectUserTyeps2($event, userIndex)" [(ngModel)]="selectedUserType"> </p-dropdown>
            </div>
            <div class="p-col-8" *ngIf="selectedUserType?.name == 'Vendor' || selectedUserType?.name == 'Employee'">
                <input type="text" pInputText placeholder="Search..." [(ngModel)]="searchValue" (ngModelChange)="onSearchChange()"/>
            </div>
            <div class="p-col-8" *ngIf="selectedUserType?.name == 'Other'">
                <input type="text" pInputText placeholder="Name" [(ngModel)]="otherName"/>
            </div>
            <ng-container *ngIf="selectedUserType?.name == 'Customer'">
                <div class="p-col-4">
                    <p-dropdown [options]="accountChannels" optionLabel="name" appendTo="body" 
                    placeholder="Select Channel" [filter]="true" [(ngModel)]="selectedAccountChannel"></p-dropdown>
                </div>
                <div class="p-col-4">
                    <input type="text" pInputText placeholder="Search..." [(ngModel)]="searchValue" (ngModelChange)="onSearchChange()"/>
                </div>
            </ng-container>
        </div>
    </div>
    <p-table *ngIf="selectedUserType?.name == 'Vendor' || selectedUserType?.name == 'Employee'"
        [value]="userlists" 
        styleClass="p-datatable-gridlines" selectionMode="single" 
        [(selection)]="selectedUserList" dataKey="id" 
        [lazy]="true"
        [paginator]="true"
        [totalRecords]="totalRecord"
        [rows]="pageSize"
        [rowsPerPageOptions]="[15, 50, 100]"
        (onPage)="onChangePageFetchData($event)">
            <ng-template pTemplate="header">
                <tr>
                    <!-- <th>ID</th> -->
                    <th>Name</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data>
                <tr [pSelectableRow]="data">
                    <!-- <td>{{ data.id }}</td> -->
                    <td>{{ data.name }}</td>
                </tr>
            </ng-template>
    </p-table>
    <p-table *ngIf="selectedUserType?.name == 'Customer'"
        [value]="userlists" 
        styleClass="p-datatable-gridlines" selectionMode="single" 
        [(selection)]="selectedUserList" dataKey="id" 
        [lazy]="true"
        [paginator]="true"
        [totalRecords]="totalRecord"
        [rows]="pageSize" 
        [rowsPerPageOptions]="[15, 50, 100]"
        (onPage)="onChangePageFetchData($event)">
            <ng-template pTemplate="header">
                <tr>
                    <th style="width:2rem"></th>
                    <th><span *ngIf="selectedUserType?.name == 'Customer'">Account </span>ID</th>
                    <th>Name</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data let-expanded="expanded">
                <tr [pSelectableRow]="data">
                    <td class="action">
                        <ng-container *ngIf="data?.hasChildAccounts">
                            <p-button type="button" pRipple [pRowToggler]="data" [text]="true" [rounded]="true" [plain]="true" (click)="onRowToggle(data)"
                                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" />
                        </ng-container>
                    </td>
                    <td>{{ data?.sequenceNumber ?? '' }}</td>
                    <td>{{ data?.businessName ?? ''}}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="rowexpansion" let-data>
                <tr *ngFor="let child of data.children" [pSelectableRow]="child">
                    <td style="text-align: center; width: 2rem">-</td>
                    <td>{{ child?.sequenceNumber ?? '' }}</td>
                    <td>{{ child?.businessName ?? '' }}</td>
                </tr>
            </ng-template>
    </p-table>
    <p-footer>
        <button type="button" pButton (click)="displayUserList=false" label="Cancel" class="p-button-secondary"></button>
        <button type="button" pButton label="Save" (click)="saveUser()" 
            [disabled]="(selectedUserType?.name == 'Vendor' || selectedUserType?.name == 'Employee' || selectedUserType?.name == 'Customer') && !selectedUserList">
        </button>
    </p-footer>
</p-dialog>